import React, { Component } from "react";
import { Link } from "react-router-dom";
import logo from "logo-red.svg";
import twitter from "twitter.svg";
import facebook from "Facebook.svg";
import linkedin from "linkedin.svg";
import insta from "insta.svg";

class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <div className="upper row">
          <div>
            <img src={logo} className="footer-4-logo" alt="go4-logo" />
          </div>
          <div className="social-links">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/go4ellis/"
            >
              <img src={facebook} alt="fb-icon" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://twitter.com/go4ellis"
            >
              <img src={twitter} alt="twtr-icon" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/go4ellis/"
            >
              <img src={insta} alt="insta-icon" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.linkedin.com/company/go4ellis/"
            >
              <img src={linkedin} alt="linkedin-icon" />
            </a>
          </div>
          <div className="text-center">
            <span className="slogan">HEALTHCARE PROVIDERS ON DEMAND</span>
            <div className="info">
              <div className="links text-left">
                <Link to="/parent/login">
                  <p>
                    Parent login
                  </p>
                </Link>
                <Link to="/patient/login">
                  <p>
                    Patient login
                  </p>
                </Link>
                <p>
                  <a href="mailto:contactus@go4.io">Contact Us</a>
                </p>
                <a target="_blank" rel="noopener noreferrer" href="https://go4.io/about-us/">
                  <p>About Us</p>
                </a>
                <p>
                  <a href="tel:883-464-2728">833-GO4-HLTH (464-4584)</a>
                </p>
              </div>
              <div className="links">
                <p>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://go4ellis.zendesk.com/hc/en-us"
                  >
                    Help
                  </a>
                </p>
                <a target="_blank" rel="noopener noreferrer" href="https://go4.io/blog/">
                  <p>Blog</p>
                </a>
                <a target="_blank" href="https://go4.io/careers/">
                  <p>Careers</p>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="lower row">
          <div>
            <span>&copy; {new Date().getFullYear()} Go4, Patent Pending</span>
          </div>

          <div>
            <span>
              <a target="_blank" rel="noopener noreferrer" href="https://go4.io/terms-and-conditions/">
                Terms &amp; Conditions
              </a>
            </span>
          </div>

          <div>
            <span>
              <a target="_blank" rel="noopener noreferrer" href="https://go4.io/privacy-policy/">
                Privacy Policy
              </a>
            </span>
          </div>

          <div>
            <span>
              <a target="_blank" href="/files/hipaa.pdf">
                HIPAA
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
